import { BrandsPage } from "./services.jsx";

export default BrandsPage;
